import _ from "lodash";
import { AVATAR_COLORS } from "Constants/colorConstants";
import { hashString } from "./StringHelpers";
import { getGlobalColorTokenHexCode } from "@toddle-edu/ds-web";

export const hex2rgba = _.memoize(
  params => hex2rgbaHelper(params),
  params => JSON.stringify(params)
);

const hex2rgbaHelper = ({ hex, alpha = 1 }) => {
  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export const getAvatarColor = id => {
  const currentColorIndex = hashString(id) % AVATAR_COLORS.length;
  return AVATAR_COLORS[currentColorIndex];
};

export const hexToArgbObject = ({ hexColor }) => {
  return { argb: _.replace(hexColor, "#", "") };
};

/**
 * Normalizes a hex color to its full 6-digit format
 * @param {string} color - The hex color to normalize
 * @returns {string} - The normalized 6-digit hex color
 */
export const normalizeHexColorCode = _.memoize((color = "") => {
  if (!_.isString(color) || !color.startsWith("#")) return "";

  const hex = color.slice(1);

  // * If 3 digits, expand to 6 digits
  if (hex.length === 3) {
    return `#${hex
      .split("")
      .map(char => char + char)
      .join("")}`;
  }

  return color;
});

// * Converts a color value to its hexadecimal code representation
export const getHexCodeFromColorToken = (color = "") => {
  if (_.isEmpty(color)) return "";

  const isHex = /^#[0-9A-F]{6}$/i.test(color);
  // * Return immediately if already a valid hex color
  if (isHex) return color;

  // * Extract CSS variable name if present
  const colorToken = color.match(/var\((--[\w-]+)\)/)?.[1];
  if (_.isEmpty(colorToken)) return "";

  const hexCode = getGlobalColorTokenHexCode(colorToken);

  // * Return full hex code from design system if token exists, otherwise empty string
  return normalizeHexColorCode(hexCode);
};
